import "./Login.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Login()
{
    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");

    const nav = useNavigate();

    useEffect(() => {
        if(window.sessionStorage.getItem("token") != null)
        {
            window.sessionStorage.removeItem("token");
        }
    }, []);

    function handleUserNameChange(e)
    {
        setUserName(e.target.value);
    }

    function handlePasswordChange(e)
    {
        setPassword(e.target.value);
    }

    function handleClick()
    {
        let url = "https://raganindustries.com/api_methods/login.php";
        let values = {
            username : username,
            password : password
        };
        console.log(url, values);
        fetch(url, {
            method : 'POST',
            headers : {
                'Accept' : 'application/json',
                'Content-type' : 'application/json'
            },
            body : JSON.stringify(values)
        }).then((response) => response.json()).then((data) => {
            if(data == "Wrong password" || data == "No user")
            {
                alert(data);
            }
            else
            {
                window.sessionStorage.setItem("token", data);
                nav("/home");
            }
        });
    }

    return(
        <div className = "container">
            <div className = "login">
                <h1>LogIn</h1>
                <input type = "text" value = { username } placeholder = "Enter username" onChange = { handleUserNameChange } />
                <div className = "border"></div>
                <br/><br/>
                <input type = "password" value = { password } placeholder = "Enter password" onChange = { handlePasswordChange } />
                <div className = "border"></div>
                <br/><br/>
                <a onClick = { () => { nav("/signin") } }>Create Account</a>
                <br/><br/>
                <input type = "submit" value = "LogIn" onClick = { handleClick } />
            </div>
        </div>
    );
}

export default Login;